import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  DeliveryNotePreferredWording,
  DeliveryNotePreferredWordingPicker,
  DeliveryNotePreferredWordingPickerProps,
} from '@work4all/components/lib/components/entity-picker/delivery-note-preferred-wording-picker/DeliveryNotePreferredWordingPicker';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<
    DeliveryNotePreferredWordingPickerProps,
    'onChange' | 'multiple' | 'value'
  > {
  error?: string;
  label?: string;
  onChange: (value: DeliveryNotePreferredWording) => void;
  value: DeliveryNotePreferredWording;
  disabled?: boolean;
}

export const DeliveryNotePreferredWordingPickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { t } = useTranslation();
  const { value, onChange, disabled } = props;

  return (
    <EntityPickerPopover
      picker={
        <DeliveryNotePreferredWordingPicker
          value={value}
          onChange={(value) => {
            onChange(value);
          }}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        disabled={disabled}
        label={t('INPUTS.DESCRIPTION')}
        value={t(`DELIVERY_NOTE_PREFERRED_WORDING.${value}`)}
      />
    </EntityPickerPopover>
  );
});
